import { render, staticRenderFns } from "./recruitmentMsg.vue?vue&type=template&id=574d2b22&scoped=true"
import script from "./recruitmentMsg.vue?vue&type=script&lang=js"
export * from "./recruitmentMsg.vue?vue&type=script&lang=js"
import style0 from "./recruitmentMsg.vue?vue&type=style&index=0&id=574d2b22&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d2b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('574d2b22')) {
      api.createRecord('574d2b22', component.options)
    } else {
      api.reload('574d2b22', component.options)
    }
    module.hot.accept("./recruitmentMsg.vue?vue&type=template&id=574d2b22&scoped=true", function () {
      api.rerender('574d2b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/recruitmentMsg.vue"
export default component.exports